import { useMutation } from "react-query";
import { changePdf } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useChangePdf = () => {
  return useMutation(changePdf);
};
